import { render, staticRenderFns } from "./NewOrganization.vue?vue&type=template&id=b4ffe45c&lang=pug"
import script from "./NewOrganization.vue?vue&type=script&lang=js"
export * from "./NewOrganization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports